/* Dogs Supreme – DS Upsell Rotator
 * Eine Benefit-Zeile am Cart-Upsell, die EINMAL durch bis zu drei Argumente laeuft
 * und auf dem ersten stehen bleibt. Kein Dauerkarussell.
 * Genutzt auf der /cart-Seite (main-cart.liquid) UND im Cart-Drawer (ds-cart-upsell.js).
 *
 * Erwartet: <div data-upsell-rotator data-bullets='["...","..."]'><span class="dsu__rot-line">…</span></div>
 *
 * Warum genau so (Stand 02.08.2026, ersetzt das endlose setInterval):
 * - Start erst bei Sichtbarkeit und IMMER bei Zeile 1. Vorher lief das Intervall ab
 *   Seitenaufbau, wer herunterscrollte stieg an zufaelliger Stelle ein. Das staerkste
 *   Argument zeigte sich nur in einem von n Faellen.
 * - Zeile 1 steht laenger als die Folgezeilen. Sie traegt den Kaufgrund.
 * - Nach einem Durchlauf zurueck auf Zeile 1, dann Ruhe. Der Warenkorb hoert auf zu
 *   flackern und der Kasse-Button bekommt seine Aufmerksamkeit zurueck.
 * - Hoechstens 3 Zeilen. Mehr liest im Warenkorb niemand.
 * - prefers-reduced-motion und Hintergrund-Tab: statisch bzw. pausiert.
 */
(function () {
  'use strict';

  var MAX_LINES  = 3;      // mehr Argumente ueberfordern die Stelle
  var HOLD_FIRST = 4500;   // ms, Ankerzeile steht laenger
  var HOLD_NEXT  = 3000;   // ms je Folgezeile
  var FADE       = 360;    // ms, muss zur CSS-Transition von .dsu__rot-line passen
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function swap(line, text, danach) {
    line.style.opacity = '0';
    setTimeout(function () {
      line.textContent = text;
      line.style.opacity = '1';
      if (danach) danach();
    }, FADE);
  }

  function lauf(el, line, bullets) {
    var i = 0;
    (function schritt() {
      el._dsRotTimer = setTimeout(function () {
        if (document.hidden) { schritt(); return; }   // im Hintergrund nicht weiterzaehlen
        i++;
        if (i < bullets.length) {
          swap(line, bullets[i], schritt);
        } else {
          swap(line, bullets[0]);                     // Schluss auf dem Anker
          el._dsRotFertig = true;
        }
      }, i === 0 ? HOLD_FIRST : HOLD_NEXT);
    })();
  }

  function start(el) {
    if (!el || el._dsRot) return;                     // idempotent
    var line = el.querySelector('.dsu__rot-line');
    if (!line) return;
    var bullets;
    try { bullets = JSON.parse(el.getAttribute('data-bullets') || '[]'); } catch (e) { bullets = []; }
    bullets = (bullets || [])
      .filter(function (b) { return b && String(b).trim(); })
      .map(function (b) { return String(b).trim(); })
      .slice(0, MAX_LINES);

    el._dsRot = true;
    if (!bullets.length) return;
    line.textContent = bullets[0];                    // nie mitten in der Sequenz einsteigen
    if (bullets.length < 2 || reduce) return;         // statisch
    lauf(el, line, bullets);
  }

  // Erst zeigen, wenn der Kunde die Stelle wirklich sieht
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (eintraege[i].isIntersecting) {
            io.unobserve(eintraege[i].target);
            start(eintraege[i].target);
          }
        }
      }, { threshold: 0.6 })
    : null;

  function scharf(el) {
    if (!el || el._dsScharf) return;
    el._dsScharf = true;
    if (io) io.observe(el); else start(el);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-upsell-rotator]');
    for (var k = 0; k < list.length; k++) scharf(list[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Drawer injiziert den Upsell dynamisch -> nach Cart-Render erneut scannen
  document.addEventListener('cart:rendered', function () { scan(); });
  document.addEventListener('ajaxProduct:added', function () { setTimeout(scan, 400); });

  // Neu eingefuegte Rotatoren (Drawer/AJAX) automatisch scharf schalten
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var nodes = muts[m].addedNodes;
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-upsell-rotator]')) scharf(node);
          else if (node.querySelector) scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.dsUpsellRotator = { scan: scan, start: start };
})();
